import PropTypes from 'prop-types';

const MemberListPropTypes = {
  listMembers: PropTypes.instanceOf(Array),
};

export default MemberListPropTypes;
